








































































































import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';
import { ALForm } from '@/common/component.types';

import { IQuote } from '@/models';
import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'QuoteCustomerRelationshipOwnerDrawerListItem',

  components: { ErrorAlert },

  props: {
    quote: Object as PropType<IQuote>
  },

  data() {
    return {
      menu: false,
      loading: false,
      isFormValid: false,
      errorMessage: '',
      detailErrorMessage: '',

      customerRelationshipOwner: this.quote.customer_relationship_owner
    };
  },

  watch: {
    'quote.customer_relationship_owner': {
      handler(value: string) {
        this.customerRelationshipOwner = value;
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      setCustomerRelationshipOwner: 'quote/setCustomerRelationshipOwner'
    }),

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    close() {
      this.menu = false;
    },

    applyQuoteCustomerRelationshipOwner(owner: number) {
      if (this.validateForm()) {
        this.clearAllErrors();
        this.loading = true;

        this.setCustomerRelationshipOwner({
          id: this.quote.number,
          customer_relationship_owner: owner
        })
          .then(() => {
            (this.$refs.customerRelationshipOwner as any).save(owner);
            this.customerRelationshipOwner = '';

            this.$emit('change');
            this.close();
          })
          .catch(error => {
            if (error.response) {
              // client received an error response that falls out of range 2xx
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
});
